.root {
  background-color: var(--mantine-color-primary-0);

  .toolbar,
  .control,
  .content,
  .controlsGroup {
    background-color: var(--mantine-color-primary-0);
  }

  .controlsGroup {
    background-color: var(--mantine-color-primary-0);

    button:where([data-active]) {
      background-color: var(--mantine-color-primary-2);
    }
  }

  .placeholder {
    color: var(--mantine-color-tertiary-7);
    font-size: 0.875rem;
  }

  :global(p.is-editor-empty:first-of-type)::before {
    color: var(--mantine-color-tertiary-7) !important;
    font-size: 0.875rem;
  }
}
